// extracted by mini-css-extract-plugin
export default {"v5c":"IncodeCaptureV5c-module__v5c-AoLR"};